export function videoSourceInit(source: HTMLIFrameElement) {
  const src = new URL(source.src)
  // checks for source (youtube needs different attributes)
  if (
    src.hostname.includes("youtube.com") ||
    src.hostname.includes("youtu.be") ||
    src.hostname.includes("youtube-nocookie.com")
  ) {
    src.searchParams.set("autoplay", "1")
    src.searchParams.set("modestbranding", "1")
    src.searchParams.set("mute", "1")
    src.searchParams.set("controls", "0")
    src.searchParams.set("showinfo", "0")
    src.searchParams.set("loop", "1")
    src.searchParams.set("enablejsapi", "1")
    const videoId = src.pathname.split("/").pop()
    if (videoId) {
      src.searchParams.set("playlist", videoId)
    }
  } else if (src.hostname.includes("vimeo.com")) {
    src.searchParams.set("autoplay", "1")
    src.searchParams.set("muted", "1")
    src.searchParams.set("controls", "0")
    src.searchParams.set("loop", "1")
    src.searchParams.set("dnt", "1")
  }

  source.src = src.toString()
}
